<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">操作日志</span>
    </div>
    <div class="content-container">
      <div class="search-container">
        <a-input placeholder="输入内容搜索" v-model="searchParams.keyword" class="medium-search-input">
          <a-icon slot="prefix" type="search" />
        </a-input>
        <a-button
            @click="onSearch"
            class="search-btn"
        >搜索</a-button>
        <a-button @click="onReset">重置</a-button>
      </div>
      <div class="list-container">
        <a-table
            :columns="tblColumns"
            :data-source="tblData"
            :pagination="pagination"
            :loading="loading"
            @change="onTableChange"
        />
      </div>
    </div>
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import { tsFormat } from "@/components/DateUtils";
import { fetchLogList } from "@/services/LogService";

const tblColumns = [
  {
    title: "操作时间",
    dataIndex: "logTime",
    width: "15%"
  },
  {
    title: "操作者",
    dataIndex: "operatorName",
    width: "10%"
  },
  {
    title: "业务分类",
    dataIndex: "contentType",
    width: "10%"
  },
  {
    title: "操作",
    dataIndex: "operationType",
    width: "10%"
  },
  {
    title: "操作内容",
    dataIndex: "logContent",
    width: "40%"
  },
  {
    title: "IP",
    dataIndex: "ipAddress",
    width: "10%"
  }
];

export default {
  components: { Breadcrumb },
  data() {
    return {
      tblColumns,
      tblData: [],
      searchParams: {
        keyword: "",
      },
      pagination: {
        size: "small",
        showQuickJumper: true
      },
      loading: false,
    };
  },
  computed: {
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    onTableChange(p) {
      this.fetchList(p.current, p.pageSize);
    },
    onSearch() {
      this.fetchList();
    },
    onReset() {
      this.searchParams.keyword = "";
      this.fetchList();
    },
    fetchList(pageNum = 1, pageSize = 10) {
      let params = {
        ...this.searchParams,
        pageNum,
        pageSize
      };

      fetchLogList(params).then(response => {
        this.loading = false;
        if (response.data.code === "FAILED") {
          console.log("服务端错误", response.data.errorMsg);
          this.$message.error("读取数据失败");
        } else {
          this.setTblData(response);
        }
      });
    },
    setTblData(response) {
      let buzData = response.data.data;
      let rltList = buzData.records;
      if (rltList) {
        rltList.forEach(item => {
          if (item.logTime) {
            item.logTime = tsFormat(item.logTime);
          }
        });
      }
      this.tblData = rltList;
      const pagination = { ...this.pagination };
      pagination.current = buzData.pageNum;
      pagination.total = buzData.total;
      pagination.pageSize = buzData.pageSize;
      pagination.showTotal = function (total, range) {
        return `当前显示 ${range[0]} - ${range[1]} 条, 共 ${total} 条`;
      };
      this.pagination = pagination;
    },

  }
};
</script>

<style scoped>

</style>
